import { TmBaseError } from '@/core/error/tmBaseError'

export class TmRepositoryError extends TmBaseError {
  public name = 'RepositoryError'
}
